import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { WelcomePage } from '../pages/welcome/welcome';
import { HomePage } from '../pages/home/home';
import { PainelPage } from '../pages/painel/painel';
import { OptionsComponent } from '../components/options/options';
import { ComercialPage } from '../pages/comercial/comercial';
import { FaturamentoPage } from '../pages/faturamento/faturamento';
import { ProducaoPage } from '../pages/producao/producao';
import { CortePage } from '../pages/corte/corte';
import { ComprasPage } from '../pages/compras/compras';

import { PeriodoFaturamentoMultilojasComponent } from '../components/periodo-fat-multilojas/periodo-fat-multilojas';
import { IndicadorFaturamentoMultilojasComponent } from '../components/indicador-fat-multilojas/indicador-fat-multilojas';
import { PeriodoPedidoMultilojasComponent } from '../components/periodo-ped-multilojas/periodo-ped-multilojas';
import { IndicadorPedidoMultilojasComponent } from '../components/indicador-ped-multilojas/indicador-ped-multilojas';
import { PeriodoProducaoMultilojasComponent } from '../components/periodo-pro-multilojas/periodo-pro-multilojas';
import { IndicadorProducaoMultilojasComponent } from '../components/indicador-pro-multilojas/indicador-pro-multilojas';
import { PeriodoProducaoCorteMultilojasComponent } from '../components/periodo-pro-corte-multilojas/periodo-pro-corte-multilojas';
import { IndicadorProducaoCorteMultilojasComponent } from '../components/indicador-pro-corte-multilojas/indicador-pro-corte-multilojas';
import { PeriodoOrdemCompraMultilojasComponent } from '../components/periodo-oc-muiltlojas/periodo-oc-muiltlojas';
import { IndicadorOrdemCompraMultilojasComponent } from '../components/indicador-oc-multilojas/indicador-oc-multilojas';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Api } from '../providers/api/api';
import { QuantidadePluralPipe } from '../pipes/quantidade-plural';
import { MomentPipe } from '../pipes/moment';

@NgModule({
    declarations: [
        MyApp,
        MomentPipe,
        QuantidadePluralPipe,
        WelcomePage, HomePage, PainelPage,
        OptionsComponent,
        ComercialPage,
        FaturamentoPage,
        ProducaoPage,
        CortePage,
        ComprasPage,
        PeriodoFaturamentoMultilojasComponent,
        IndicadorFaturamentoMultilojasComponent,
        PeriodoPedidoMultilojasComponent,
        IndicadorPedidoMultilojasComponent,
        PeriodoProducaoMultilojasComponent,
        IndicadorProducaoMultilojasComponent,
        PeriodoProducaoCorteMultilojasComponent,
        IndicadorProducaoCorteMultilojasComponent,
        PeriodoOrdemCompraMultilojasComponent,
        IndicadorOrdemCompraMultilojasComponent
    ],
    imports: [
        BrowserModule,
        HttpModule,
        IonicModule.forRoot(MyApp, {
            platforms: {
                ios: {
                    backButtonText: 'Voltar',
                }
            }
        }),
        IonicStorageModule.forRoot()
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        WelcomePage, HomePage, PainelPage,
        OptionsComponent,
        ComercialPage,
        FaturamentoPage,
        ProducaoPage,
        CortePage,
        ComprasPage,
        PeriodoFaturamentoMultilojasComponent,
        IndicadorFaturamentoMultilojasComponent,
        PeriodoPedidoMultilojasComponent,
        IndicadorPedidoMultilojasComponent,
        PeriodoProducaoMultilojasComponent,
        IndicadorProducaoMultilojasComponent,
        PeriodoProducaoCorteMultilojasComponent,
        IndicadorProducaoCorteMultilojasComponent,
        PeriodoOrdemCompraMultilojasComponent,
        IndicadorOrdemCompraMultilojasComponent
    ],
    providers: [
        StatusBar,
        SplashScreen,
        Api,
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts